import { useMemo } from 'react';
import { useLocalSearchParams } from 'expo-router';

import { useClient } from 'urql';
import { fromPromise } from 'xstate5';

import { type HasActiveBagQuery, HasActiveBagDocument } from '../../graphql/CartHandoff.generated';
import {
  type FetchInitialDataParams,
  type FetchInitialDataResponse,
} from '../../machine/cart-handoff-machine.actors';

/**
 * Returns the order token from the URL and whether the customer has an active bag.
 */
export const useFetchInitialData = () => {
  const client = useClient();

  const { orderToken } = useLocalSearchParams<{ orderToken?: string }>();

  const fetchInitialData = useMemo(
    () =>
      fromPromise<FetchInitialDataResponse, FetchInitialDataParams>(async () => {
        const hasActiveBagQuery = client.query<HasActiveBagQuery>;

        const response = await hasActiveBagQuery(HasActiveBagDocument, {}).toPromise();
        const lineItems = response.data?.cart?.lineItems ?? [];
        const hasActiveBag = lineItems.length > 0;

        return {
          orderToken,
          hasActiveBag,
        };
      }),
    [client.query, orderToken],
  );

  return { fetchInitialData };
};
